module.exports = __webpack_public_path__ + "img/undraw_businessman_97x4.8e9bccfa.svg";